import React, { useEffect, useState } from 'react';
import '../styles/UgcNetRegistrations.css';

const UgcNetRegistrations = () => {
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/ugcnet/all')

      .then(res => res.json())
      .then(data => {
        setRegistrations(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="ugcnet-wrapper">
      <h2>UGC NET Registrations</h2>
      {loading ? (
        <div className="loader">Loading registrations...</div>
      ) : (
        <table className="ugcnet-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Demo Date</th>
            </tr>
          </thead>
          <tbody>
            {registrations.map((row) => (
              <tr key={row.id}>
                <td>{row.id}</td>
                <td>{row.name}</td>
                <td>{row.email}</td>
                <td>{row.mobile}</td>
                <td>{row.demoDate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default UgcNetRegistrations;
